import { default as Input, InputProps } from "antd/lib/input"
import React from "react"

const Password = (props: InputProps): JSX.Element => (
  <Input.Password {...props} />
)

export default Password
